import type React from "react"

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large"
  color?: string
}

const sizeMap = {
  small: "w-3 h-3",
  medium: "w-4 h-4",
  large: "w-5 h-5",
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = "medium", color = "currentColor" }) => {
  return (
    <svg className={`animate-spin ${sizeMap[size]} mr-2`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke={color} strokeWidth="4" />
      <path className="opacity-75" fill={color} d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
  )
}
